/**
 * Legacy import path — delegates to the shared apiClient (auth refresh, 401 retry, dedup).
 * Prefer `import { apiClient } from '@/services/apiClient'` for new code.
 */
import { apiClient } from './apiClient';

export const api = apiClient;
export default api;
